const toFixedMB = (bytes: number) => (Math.round(bytes / 1024) / 1024).toFixed(2);

export default toFixedMB;
